import { render, staticRenderFns } from "./HistoricoPadrao.vue?vue&type=template&id=51c7a4d1&"
import script from "./HistoricoPadrao.vue?vue&type=script&lang=js&"
export * from "./HistoricoPadrao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports